/** @jsx jsx */
import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';

import { Text } from '../Texts';
import { ICustomTheme } from 'interfaces';

const Wrapper = styled('div')`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;

export const StyledCircularProgress = styled(CircularProgress)<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  color: theme.colors.paletteFromBO.main,
}));

export const Loader: React.FC<{ label?: string }> = ({ label }) => (
  <Wrapper>
    <div>
      <StyledCircularProgress size={50} />
      <Text
        css={css`
          margin-top: 1rem;
        `}
        text={label}
        size="body2"
      />
    </div>
  </Wrapper>
);

export default Loader;
